import {
  DateUtilInstance,
  formatDateISO,
  parseDateUnknown,
} from '@zorro/shared/formatters';

export function minimalDate(
  // eslint-disable-next-line sonarjs/use-type-alias
  dateDefinitelyExists: string | DateUtilInstance | Date,
  // eslint-disable-next-line sonarjs/use-type-alias
  ...additionalDates: (string | DateUtilInstance | Date | null | undefined)[]
): DateUtilInstance {
  let minDate = parseDateUnknown(dateDefinitelyExists);

  for (const date of additionalDates) {
    if (date) {
      const parsedDate = parseDateUnknown(date);
      if (parsedDate.isBefore(minDate)) {
        minDate = parsedDate;
      }
    }
  }

  return minDate;
}

export function minimalDateISO(
  dateDefinitelyExists: string | DateUtilInstance | Date,
  ...additionalDates: (string | DateUtilInstance | Date | null | undefined)[]
): string {
  const minDate = minimalDate(dateDefinitelyExists, ...additionalDates);
  return formatDateISO(minDate);
}

export function maximalDate(
  dateDefinitelyExists: string | DateUtilInstance | Date,
  ...additionalDates: (string | DateUtilInstance | Date | null | undefined)[]
): DateUtilInstance {
  let maxDate = parseDateUnknown(dateDefinitelyExists);

  for (const date of additionalDates) {
    if (date) {
      const parsedDate = parseDateUnknown(date);
      if (parsedDate.isAfter(maxDate)) {
        maxDate = parsedDate;
      }
    }
  }

  return maxDate;
}

export function maximalDateISO(
  dateDefinitelyExists: string | DateUtilInstance | Date,
  ...additionalDates: (string | DateUtilInstance | Date | null | undefined)[]
): string {
  const maxDate = maximalDate(dateDefinitelyExists, ...additionalDates);
  return formatDateISO(maxDate);
}

export function maybeMinimalDate(
  ...dates: (string | DateUtilInstance | Date | null | undefined)[]
): DateUtilInstance | undefined {
  let minDate;

  for (const date of dates) {
    if (date) {
      const parsedDate = parseDateUnknown(date);
      if (!minDate || parsedDate.isBefore(minDate)) {
        minDate = parsedDate;
      }
    }
  }

  return minDate;
}

export function maybeMinimalDateISO(
  ...dates: (string | DateUtilInstance | Date | null | undefined)[]
): string | undefined {
  const minDate = maybeMinimalDate(...dates);
  return minDate ? formatDateISO(minDate) : undefined;
}

export function maybeMaximalDate(
  ...dates: (string | DateUtilInstance | Date | null | undefined)[]
): DateUtilInstance | undefined {
  let maxDate;

  for (const date of dates) {
    if (date) {
      const parsedDate = parseDateUnknown(date);
      if (!maxDate || parsedDate.isAfter(maxDate)) {
        maxDate = parsedDate;
      }
    }
  }

  return maxDate;
}

export function maybeMaximalDateISO(
  ...dates: (string | DateUtilInstance | Date | null | undefined)[]
): string | undefined {
  const maxDate = maybeMaximalDate(...dates);
  return maxDate ? formatDateISO(maxDate) : undefined;
}
